// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"8":"editor","419":"wiki","542":"overview","884":"admin"}[chunkId] + "." + {"8":"5262ec31","419":"06be226a","542":"8c0b2d2f","884":"5825581e"}[chunkId] + ".css";
};